(function () {
  const navToggle = document.querySelector("[data-nav-toggle]");
  const nav = document.querySelector("[data-site-nav]");

  if (navToggle && nav) {
    const closeNavigation = function () {
      nav.classList.remove("is-open");
      navToggle.setAttribute("aria-expanded", "false");
    };

    navToggle.addEventListener("click", function () {
      const isOpen = nav.classList.toggle("is-open");
      navToggle.setAttribute("aria-expanded", isOpen ? "true" : "false");
    });

    nav.addEventListener("click", function (event) {
      if (event.target.closest("a")) closeNavigation();
    });

    document.addEventListener("keydown", function (event) {
      if (event.key === "Escape" && nav.classList.contains("is-open")) {
        closeNavigation();
        navToggle.focus();
      }
    });

    window.addEventListener("resize", function () {
      if (window.innerWidth > 920) closeNavigation();
    });
  }

  const query = new URLSearchParams(window.location.search);
  const design = query.get("design");
  const interest = query.get("interest");
  const contactForm = document.querySelector(".contact-form");

  if (contactForm && design) {
    const message = contactForm.querySelector('textarea[name="contact[body]"]');
    const interestSelect = contactForm.querySelector('select[name="contact[interest]"]');

    if (message && !message.value) message.value = design;
    if (interestSelect && interest) {
      const matchingOption = Array.from(interestSelect.options).find(function (option) {
        return option.text === interest;
      });
      if (matchingOption) interestSelect.value = matchingOption.value;
    }
  }
})();
